import { createContext, FC, useState, useMemo } from 'react';
import { translations } from '../translations';

export enum LanguagesEnum {
  DE = 'DE',
  EN = 'EN'
}

export interface ILanguages {
  EN: string;
  DE: string;
}

interface ITranslation {
  translate: (t: string | ILanguages) => any;
  language: LanguagesEnum;
  setLanguage: React.Dispatch<React.SetStateAction<LanguagesEnum>>;
}

export const TranslationContext = createContext<ITranslation>({} as any);

const setInitLang = () => {
  let setLang: LanguagesEnum | undefined;
  if (typeof localStorage !== 'undefined') {
    setLang = localStorage.getItem('language') as LanguagesEnum;
  }

  if (!setLang && typeof navigator !== 'undefined') {
    let browserLang = navigator.language;
    browserLang = browserLang?.slice(0, 2).toUpperCase();
    setLang = LanguagesEnum[browserLang];
  }

  return setLang || LanguagesEnum.DE;
};

export const TranslationHandler: FC = ({ children }) => {
  const [language, setLanguage] = useState<LanguagesEnum>(setInitLang());

  const translate = useMemo(
    () => (t: string | ILanguages) => {
      return typeof t === 'string'
        ? translations[language]?.[t] || t
        : t?.[language] || t;
    },
    [language]
  );

  return (
    <TranslationContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </TranslationContext.Provider>
  );
};
